import React from "react";
import { Card } from "flowbite-react";
import { useStore } from "../../store";

/**
 * Shown when the employer account exists but the company is not active yet.
 * No product chrome — user cannot access jobs until status is activated in the DB.
 */
const AccountInactive = () => {
  const email = useStore((state) => state.user?.email);

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 px-4">
      <Card className="w-full max-w-lg p-8">
        <h1 className="text-h5 font-semibold text-gray-900 mb-3">
          Account not active yet
        </h1>
        <p className="text-gray-600 mb-4">
          Your organization&apos;s access hasn&apos;t been turned on. Please contact
          your June account manager to activate your company.
        </p>
        {email ? (
          <p className="text-small text-gray-500">
            Signed in as <span className="font-medium text-gray-700">{email}</span>
          </p>
        ) : null}
      </Card>
    </div>
  );
};

export default AccountInactive;
